const PAYMENT_STEPS = {
  SELECT_CLIENT: 1,
  SELECT_AMOUNT: 2,
  PAYMENT_DETAIL: 3,
  PAYMENT_METHOD: 4,
  WALLET_PAYMENT: 5,
  BANK_DEPOSIT: 6,
  SCHEDULE_PAYMENT: 7,
  SUCCESS: 100,
  PENDING_OF_TRANSFER: 110,
  ERROR: 101,
  NOT_PROCESSED: 102,
};

export default PAYMENT_STEPS;
